import { HubSectionType } from 'utils/gloo-types';
import Button from 'components/atoms/Button';
import { SectionPrefix, StartPageState } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/types';

export default function StartPageOptions({
  startPageState,
  setStartPageState,
}: {
  startPageState: StartPageState;
  setStartPageState: (nextState: StartPageState) => void;
}) {
  return (
    <div className="flex flex-col m-auto max-w-[240px]">
      <Button
        className="mb-3 justify-center font-normal"
        type={startPageState === SectionPrefix.FullWidth ? 'gray-toggle' : 'tertiary'}
        onClick={() => {
          setStartPageState(SectionPrefix.FullWidth);
        }}
        dataDurableId="FullWidthSectionButton"
        text="Full Width"
      />
      <Button
        className="mb-3 justify-center font-normal"
        type={startPageState === SectionPrefix.FiftyFifty ? 'gray-toggle' : 'tertiary'}
        onClick={() => {
          setStartPageState(SectionPrefix.FiftyFifty);
        }}
        dataDurableId="SplitWidthSectionButton"
        text="50/50"
      />
      <Button
        className="justify-center font-normal"
        type={startPageState === HubSectionType.RESOURCE ? 'gray-toggle' : 'tertiary'}
        onClick={() => {
          setStartPageState(HubSectionType.RESOURCE);
        }}
        dataDurableId=""
        text="Resource"
      />
    </div>
  );
}
